import { render, staticRenderFns } from "./FormatoListaEmpresas.vue?vue&type=template&id=9c8803e6"
import script from "./FormatoListaEmpresas.vue?vue&type=script&lang=js"
export * from "./FormatoListaEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports